<template>
    <div class="form-element__container" :id="fullFormIdentifier + '-container'">
        <input
            :id="fullFormIdentifier"
            v-model="firstName"
            :class="{ 'form-element__input--active': firstName !== '' }"
            class="form-element__input"
            type="text"
            data-validate="input"
            data-validate-message="Please enter your first name"
            :data-error-target="fullFormIdentifier + '-container'"
            name="first-name"
            autocomplete="off"
            placeholder="First Name *"
            :readonly="readonly"
        />
    </div>
</template>

<script>
export default {
  props: {
    formIdentifier: {
      type: String,
      default: 'form',
    },
    readonly:{
      type: Boolean,
      default: false
    },
  },
  computed: {
    firstName: {
      get: function () {
        return this.$store.state.CustomerData.firstName;
      },
      set: function (newValue){
        this.$store.dispatch("CustomerData/storeCustomerData", {firstName: newValue});
      }
    },
    fullFormIdentifier() {
      return this.formIdentifier + '-' + this._uid;
    },
  }
}
</script>
